<template>
  <div class="product-center-box">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <img src="../assets/img/anli-banner1.jpg" class="center-block w100" alt="" />
      </swiper-slide>
    </swiper>
    <div
      class="w100 pt-39.2 pb-48"
      :class="index % 2 == 0 ? 'bg2' : 'bg1'"
      v-for="(item, index) in producrInfoList"
      :key="index"
    >
      <div class="container">
        <div class="producr-info-box">
          <div class="producr-info-content row">
            <div v-if="index % 2 == 0">
              <div class="producr-desc-box col-lg-6 col-xs-12">
                <div class="producr-desc-title">
                  <img :src="item.mainImg" alt="" srcset="" />
                </div>
                <div class="producr-desc-text">
                  {{ item.desc }}
                </div>
                <div class="producr-tag-box">
                  <div
                    class="producr-tag"
                    v-for="(item1, index1) in item.tag"
                    :key="index1"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </div>
              <div class="producr-img-box flex-item-center col-lg-6 col-xs-12">
                <img :src="item.img1" class="producr-img" alt="" srcset="">
              </div>
            </div>
            <div v-if="index % 2 != 0">
              <div class="producr-img-box flex-item-center col-lg-6 col-xs-12">
                <img :src="item.img1" class="producr-img" alt="" srcset="" />
              </div>
              <div class="producr-desc-box col-lg-6 col-xs-12">
                <div class="producr-desc-title">
                  <img :src="item.mainImg" alt="" srcset="" />
                </div>
                <div class="producr-desc-text">
                  {{ item.desc }}
                </div>
                <div class="producr-tag-box">
                  <div
                    class="producr-tag"
                    v-for="(item1, index1) in item.tag"
                    :key="index1"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w100 hezuo-bg pt-48 pb-48">
      <div class="title-box pb-25.6">
            <div class="title">合作伙伴</div>
            <div class="subtitle">PARTENR</div>
          </div>
      <img src="../assets/img/hezuo.png" class="center-block" alt="" srcset="">
    </div>
    <!-- <shiyong></shiyong> -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import shiyong from "@/components/shiyong.vue";

export default {
  name: "case",
  components: {
    bottomFooter,
    shiyong
  },
  data() {
    return {
      swiperOption: {
        loop: false,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
          clickable: true,
        },
      },
      producrInfoList: [
        {
          title: "一站式互联网医院解决方案 优化医疗资源分配",
          mainImg: require("@/assets/img/yiyuan-name1.png"),
          desc: `惠宾科技凭借其卓越的技术实力，为西京医院精心构建了一个全面的医疗信息化解决方案。这一系统集成了号源管理、预住院服务、预约挂号、支付对账等多项关键功能，极大地提升了医院的服务质量和工作效率。通过这一平台，西京医院能够更加高效地管理患者信息，优化就诊流程，实现了医疗资源的合理分配。这些改进不仅显著提高了医院的运营效能，还为患者提供了更加便捷、高效的就医体验，体现了惠宾科技在医疗信息化领域的专业实力和贡献。`,
          tag: ["预约挂号", "号源管理", "支付对账", "预住院"],
          img1: require("@/assets/img/anli5.png"),
          // img2:require("@/assets/img/anli0002.png")
        },
        {
          title: "支持多样化预约挂号方式 满足不同患者需求",
          mainImg: require("@/assets/img/yiyuan-name2.png"),
          desc: `惠宾科技携手唐都医院，倾力打造了一套全面而先进的医疗信息化产品。这一系列包含号源管理、医技预约、排队叫号、预住院等功能，旨在为唐都医院的院方和广大患者提供卓越且便捷的服务体验。这些功能的集成不仅极大地提升了医院的运营效率，优化了就诊流程，还为患者创造了一个更加便捷、高效的就医环境。院方和患者都纷纷表示，这些改进给他们带来了全新的、良好的体验，对惠宾科技的专业技术和服务水平给予了高度评价。`,
          tag: ["号源管理", "医技预约", "排队叫号", "预住院"],
          img1: require("@/assets/img/anli6.png"),
          // img2:require("@/assets/img/anli4.png"),
        },
        {
          title: "在线问诊-药品邮寄送到家 满足不同患者需求",
          mainImg: require("@/assets/img/yiyuan-name3.png"),
          desc: `惠宾科技携手红会医院，共同打造了一个高效、智能的医疗信息化系统。这一系统集成了统一对账平台、患者服务平台、排队叫号以及统一号源管理等关键功能，旨在为医院提供全面而高效的信息化解决方案。通过这一平台的建设，惠宾科技不仅为红会医院的信息化发展贡献了重要力量，还极大地提升了患者的就医体验。患者可以更加便捷地预约挂号、查询信息，享受到更加高效、个性化的服务。这些改进不仅体现了惠宾科技的技术实力和服务水平，也展现了其在医疗信息化领域的深厚积累和卓越贡献。`,
          tag: ["统一对账平台", "患者服务平台", "排队叫号", "统一号源"],
          img1: require("@/assets/img/anli7.png"),
          // img2:require("@/assets/img/anli4.png"),
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">

@mixin content-text-font{
	font-size: 1.6rem;
	color: #333333;
	font-weight: 400;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	line-height: 2.4rem;
}
.hezuo-bg{
  background-color: #F2F8FF;
}
.title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 3.6rem;
  color: #333333;
}
.subtitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 1.4rem;
  color: #999999;
}
.title-box{
  text-align: center;
  .title{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 3.6rem;
    color: #333333;
  }
  .subtitle{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 1.4rem;
    color: #999999;
  }
}
.producr-info-box {
  .producr-info-content {
    padding-top: 15.6rem;
    &:first-child {
      padding-top: 0;
    }
  }
  .producr-desc-box {
    .producr-desc-title {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      color: #0e2050;
    }
    .producr-desc-text {
      padding-top: 2.4rem;
      @include content-text-font;
    }
    .producr-tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 3.2rem;
      .producr-tag {
        margin-right: 2.6rem;
        margin-bottom: 8px;
        padding: 2px 8px;
        background-color: rgba(0, 40, 128, 0.09);
        border-radius: 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #002880;
      }
    }
  }
  .producr-img-box {
    .producr-img:nth-child(even) {
      margin-left: 40px;
    }
  }
}

</style>
